import { UserPreferenceContext } from '@contexts/user-preference-context';
import {
  Dropdown,
  DropdownItem,
  Icon,
  ToolTip,
  usePopper,
  useTranslation,
} from '@testsigma/atoms';
import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const AddonCustomFieldMenu = () => {
  const { t } = useTranslation();
  const [showDropdown, toggleDropdown] = useState(false);
  const [btnRef, setBtnRef] = useState(null);
  const offsetModifier = [
    {
      name: 'offset',
      options: {
        offset: [35, 12],
      },
    },
  ];
  const [dropdownRef, setDropdownRef] = useState(null);
  const { styles, attributes } = usePopper(btnRef, dropdownRef, {
    placement: 'top',
    strategy: 'fixed',
    modifiers: offsetModifier,
  });
  const navigate = useNavigate();
  const { userPreference } = useContext(UserPreferenceContext);

  return (
    <>
      <ToolTip
        content={t('left.nav.addons')}
        placement='top'
        align='center'
        className='inline-flex overflow-hidden justify-center border-[0.5px] mr-2 rounded-md p-1.5 border-secondary-100 shadow hover:bg-secondary-50 text-unique-800 cursor-pointer bg-secondary-unique-1000'>
        <div
          ref={setBtnRef}
          onClick={() => toggleDropdown(!showDropdown)}
          className={`flex justify-center text-unique-800 ${
            showDropdown ? 'bg-slate-200' : ''
          }`}>
          <Icon name='addons' className='text-[20px]' />
        </div>
      </ToolTip>
      {showDropdown && (
        <Dropdown
          className='w-[172px] z-[1000]'
          toggleDropdown={toggleDropdown}
          setRef={setDropdownRef}
          style={styles.popper}
          attributes={attributes.popper}>
          <DropdownItem
            onClick={() => {
              toggleDropdown(false);
              navigate('/addons');
            }}
            className='px-lg py-md text-[14px] flex items-center text-unique-800 hover:bg-secondary-50 rounded'>
            <span>{t('left.nav.addon.popup.name')}</span>
          </DropdownItem>

          <DropdownItem
            onClick={() => {
              toggleDropdown(false);
              navigate(
                `/td/${userPreference?.preference?.projectPreference?.versionId}/functions`,
              );
            }}
            className='px-lg py-md text-[14px] flex items-center text-unique-800 hover:bg-secondary-50 rounded'>
            <span>{t('left.nav.custom_functions')}</span>
            <ToolTip
              tooltipClassName='w-72'
              content={t('custom_function.deprecated.tooltip.data')}
              placement='right'
              align='center'
            >
              <Icon
                name='extension-off'
                className='w-5 h-5 ml-3 text-orange-500'
              />
            </ToolTip>
          </DropdownItem>
        </Dropdown>
      )}
    </>
  );
};

export default AddonCustomFieldMenu;
